import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { FilterSectionProps, FilterSection } from '@src/quince-components/src'
import {
  FilterSectionWithDrawer,
  FilterWithSidebar,
  MobileFilters,
} from '@src/quince-components/src/atoms/filterSection/menu'
import { UpdateQueryParams } from '@src/quince-components/src/atoms/filterSection/menu/filterSection.interface'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { COLOR_PAGES_RENDERED_PATHS } from '../../collection.constants'
import Collection, { COLLECTION_PAGE_TYPE } from '../../domains/Collection'
import { Filter, SelectedFilter } from '../../domains/CollectionFilter'

interface CollectionFiltersProps {
  totalProductsCount: number
  initialFilters: Filter[]
  sortBy: string
  selectedFilters: SelectedFilter
  updateQuery: (params: UpdateQueryParams) => void
  collectionPage: Collection
  newCLPFiltersDesktopBucket: STATSIG_EXPERIMENTS_BUCKETS | null
  newCLPFiltersMobileBucket: STATSIG_EXPERIMENTS_BUCKETS | null
  showLoader?: boolean
}

const CollectionFilters = ({
  totalProductsCount,
  initialFilters,
  sortBy,
  selectedFilters,
  updateQuery,
  collectionPage,
  newCLPFiltersDesktopBucket,
  newCLPFiltersMobileBucket,
  showLoader,
}: CollectionFiltersProps) => {
  const { deviceType } = useDeviceInfo()
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP

  function getFilterSectionComponent(): React.FC<FilterSectionProps> {
    if (isDesktop) {
      switch (newCLPFiltersDesktopBucket) {
        case STATSIG_EXPERIMENTS_BUCKETS.GROUP_A:
        case STATSIG_EXPERIMENTS_BUCKETS.GROUP_C:
          return FilterSectionWithDrawer
        case STATSIG_EXPERIMENTS_BUCKETS.GROUP_B:
        case STATSIG_EXPERIMENTS_BUCKETS.GROUP_D:
          return FilterWithSidebar
        default:
          return FilterSection
      }
    } else if (
      newCLPFiltersMobileBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_A ||
      newCLPFiltersMobileBucket === STATSIG_EXPERIMENTS_BUCKETS.GROUP_B
    ) {
      return MobileFilters
    }

    return FilterSection
  }

  function renderFilterSection(Component: React.FC<FilterSectionProps>) {
    return (
      <Component
        noOfItems={totalProductsCount}
        filters={initialFilters}
        sortBy={sortBy}
        selectedFilters={selectedFilters}
        updateQuery={updateQuery}
        showSelectedOption={sortBy !== ''}
        shouldRenderColorFilterHtml={COLOR_PAGES_RENDERED_PATHS.has(collectionPage.slug)}
        collectionSlug={collectionPage.slug}
        hideFilters={collectionPage.collectionPageType === COLLECTION_PAGE_TYPE.BUNDLE}
        showShimmer={showLoader}
      />
    )
  }

  return renderFilterSection(getFilterSectionComponent())
}

export default CollectionFilters
